import { make } from 'vuex-pathify';
import axios from "axios";
import { triggerError } from "@/components/helpers/error-handler";

const timeout = 600000; //10 minutes

const getDefaultState = () => {
  return {
    developments: [],
    developmentsUpdated: null,
    development: {},
    developmentRef: null,
    developmentUpdated: null,
    developmentBills: [],
    developmentBillsUpdated: null,
    developmentAccounts: [],
    developmentAccountsUpdated: null,
  }
}

const state = getDefaultState();

const actions = {
  async getDevelopmentList({ state, commit }) {
    try {
      const time = new Date().getTime();

      if (state.developmentsUpdated && time - state.developmentsUpdated < timeout) {
        return true;
      }

      const { data } = await axios({
        url: process.env.VUE_APP_API_URL + "credit-billing"
      });

      commit('store_developments', { data, time });

      return true;
    } catch (error) {
      return triggerError(error);
    }
  },
  async getDevelopment({ state, commit }, { developmentRef }) {
    try {
      const time = new Date().getTime();

      if (state.developmentUpdated && state.developmentRef === developmentRef && time - state.developmentUpdated < timeout) {
        return true;
      }

      const { data } = await axios({
        url: process.env.VUE_APP_API_URL + "credit-billing/development/" + developmentRef
      });

      commit('store_development', { developmentRef, data, time });

      return true;
    } catch (error) {
      return triggerError(error);
    }
  },
  async getDevelopmentBills({ commit }, { developmentRef }) {
    try {
      const time = new Date().getTime();

      const { data } = await axios({
        url: process.env.VUE_APP_API_URL + "credit-billing/development/" + developmentRef + "/all-bills"
      });

      commit('store_development_bills', { data, time });

      return true;
    } catch (error) {
      return triggerError(error);
    }
  },
  async getDevelopmentAccounts({ commit }, { developmentRef }) {
    try {
      const time = new Date().getTime();

      const { data } = await axios({
        url: process.env.VUE_APP_API_URL + "credit-billing/development/" + developmentRef + "/accounts"
      });

      commit('store_development_accounts', { data, time });

      return true;
    } catch (error) {
      return triggerError(error);
    }
  },
  resetCreditBillingState ({ commit }) {
    commit('resetState')
  },
};

const mutations = {
  ...make.mutations(state),
  store_developments(state, {data, time}) {
    state.developments = data;
    state.developmentsUpdated = time;
  },
  store_development_bills(state, {data, time}) {
    state.developmentBills = data;
    state.developmentBillsUpdated = time;
  },
  store_development_accounts(state, {data, time}) {
    state.developmentAccounts = data;
    state.developmentAccountsUpdated = time;
  },
  store_development(state, {developmentRef, data, time}) {
    state.development = data;
    state.developmentRef = developmentRef;
    state.developmentUpdated = time;
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
};

const getters = {
  ...make.getters(state)
};

export const creditBilling = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
